/**
 * A roster row's name on a HELM section (A7Y-5210), linked to where the row
 * lives in the app: its account page, or This week for a row with no account.
 * A7Y-5342, A7Y-5492: the link carries what the row is about, its next action
 * follows, and the full text sits behind "Show more" — a row is never its
 * whole history.
 */
import type { HelmCommitment } from '@a7y/platform-health/helm';
import { helmCommitmentMarkdown, helmRowSummary } from '@a7y/platform-health/helm';
import { RowMore } from '../crm/CrmMarkdown';
import { HelmLink } from './HelmLink';

export function RowName({ commitment }: { commitment: HelmCommitment }) {
  const url = commitment.evidence.ref.url;
  const markdown = helmCommitmentMarkdown(commitment);
  const { ask, next } = helmRowSummary(markdown, {
    decision: commitment.table === 'scheduled_decisions',
  });
  return (
    <>
      {url ? (
        <HelmLink href={url} className="hover:underline" data-testid="helm-row-link">
          {ask}
        </HelmLink>
      ) : (
        ask
      )}
      {next ? (
        <span
          className="block text-xs text-zinc-600 dark:text-zinc-400"
          data-testid="helm-row-next"
        >
          {next}
        </span>
      ) : null}
      <RowMore markdown={markdown} testId="helm-row-name-more" />
    </>
  );
}
